import img1 from "../../../assets/images/125_Khz.png";
import img2 from "../../../assets/images/BLE_Mobile.png";
import img3 from "../../../assets/images/NFC.png";
import img4 from "../../../assets/images/Smart_13.56_MHz.png";

export const readersData = [
  {
    id: 1,
    title: "125 KHz",
    image: img1,
  },
  {
    id: 2,
    title: "BLE Mobile",
    image: img2,
  },
  {
    id: 3,
    title: "NFC",
    image: img3,
  },
  {
    id: 4,
    title: "Smart 13.56 MHz",
    image: img4,
  },
];
